import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

import TextFormat from './../TextFormat';
import Utils from './../Utils';

const MAX_OPACITY = 0.95;

const POPUP_SATURATION = '60%';
const POPUP_BG_LUMINANCE = '96%';
const POPUP_OL_LUMINANCE = '30%';

const POPUP_HEIGHT_THRESHHOLD = 125;
const POPUP_WIDTH_THRESHHOLD = 400;

const PopupBox = styled.div`
    z-index: 1000;
    padding: 0.5rem 0 0 0.75rem;
    position: fixed;
    max-width: 22.5rem;
    border-radius: 0.35rem;
    box-shadow: 0.5rem 0.75rem 1.0rem rgba(0,0,0,0.35);
    opacity: 0;
`;

const PopupBoxTitle = styled.div`
    font-family: Courier;
    margin-bottom: 0.5rem;
    font-weight: bold;
    font-size: 1.25rem;
    text-align: left;
    letter-spacing: 0.05rem;
    text-decoration: underline;
    color: rgba(0,0,0,0.9);
    cursor: pointer;
`;

const PopupBoxSubject = styled.div`
    font-style: italic;
    color: rgba(0,0,0,0.8);
    font-weight: normal;
    text-align: left;
    font-size: 0.95rem;
    padding-right: 0.75rem;
    padding-bottom: 0.75rem;
`;

const PopupBoxFooter = styled.div`
    font-style: italic;
    text-align: right;
    font-weight: normal;
    font-size: 0.85rem;
    padding-bottom: 0.15rem;
    padding-right: 0.5rem;
`;

export class ReferencePopup extends Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired,
        hue: PropTypes.number.isRequired,
        subject: PropTypes.string.isRequired,
        close_popup: PropTypes.func.isRequired,
        on_reference_click: PropTypes.func.isRequired
    }

    state = {
        popup_ref: React.createRef(),
        fade_interval: null,
    };

    componentDidMount() {
        const {popup_ref} = this.state;
        const webmain = document.getElementById("webmain");
        webmain.addEventListener('scroll', this.handleScroll)
        document.addEventListener('click', this.clear_popup);

        const fade_interval = Utils.animate(popup_ref, 125, 0, MAX_OPACITY, (value, is_last) => {
            popup_ref.current.style.opacity = value;
        });
        this.setState({fade_interval: fade_interval})
    }

    componentWillUnmount() {
        this.clear_popup()
        const webmain = document.getElementById("webmain");
        webmain.removeEventListener('scroll', this.handleScroll)
        document.removeEventListener('click', this.clear_popup);
    }

    handleScroll = (event) => {
        this.clear_popup();
    };

    clear_popup = () => {
        const {popup_ref} = this.state;
        const {close_popup} = this.props;
        const new_interval = Utils.animate(popup_ref, 350, MAX_OPACITY, 0, (value, is_last) => {
            popup_ref.current.style.opacity = value;
            if (is_last) {
                close_popup()
            }
        });
        this.setState({fade_interval: new_interval})
    }

    render() {
        const {popup_ref} = this.state;
        const {title, text, x, y, hue, subject, on_reference_click} = this.props;
        let popup_style = {
            left: x, top: y,
            backgroundColor: `hsl(${hue}, ${POPUP_SATURATION}, ${POPUP_BG_LUMINANCE})`,
            border: `0.1rem solid hsl(${hue}, ${POPUP_SATURATION}, ${POPUP_OL_LUMINANCE})`
        }
        if (window.innerHeight - y < POPUP_HEIGHT_THRESHHOLD) {
            popup_style.top = window.innerHeight - POPUP_HEIGHT_THRESHHOLD;
        }
        if (window.innerWidth - x < POPUP_WIDTH_THRESHHOLD) {
            popup_style.left = window.innerWidth - POPUP_WIDTH_THRESHHOLD;
        }
        const footer = <TextFormat text={`more in reference: **${subject}**`}/>
        return <PopupBox ref={popup_ref} style={popup_style} onClick={e => this.clear_popup()}>
            <PopupBoxTitle
                onClick={e => on_reference_click(title)}
                title={`click for a more complete description of "${title}"`}>
                {title}
            </PopupBoxTitle>
            <PopupBoxSubject>
                <TextFormat text={text} is_first={true} of_many={false}/>
            </PopupBoxSubject>
            <PopupBoxFooter>{footer}</PopupBoxFooter>
        </PopupBox>;
    }
}

export default ReferencePopup;
